/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as publicIndexRouteImport } from './routes/(public)/index'
import { Route as publicApplyRouteImport } from './routes/(public)/apply'
import { Route as publicForgotPasswordRouteImport } from './routes/(public)/forgot-password'
import { Route as publicJoinRouteImport } from './routes/(public)/join'
import { Route as publicLoginRouteImport } from './routes/(public)/login'
import { Route as publicResetPasswordRouteImport } from './routes/(public)/reset-password'
import { Route as AuthenticatedBillingRouteRouteImport } from './routes/_authenticated/billing/route'
import { Route as AuthenticatedContactsRouteRouteImport } from './routes/_authenticated/contacts/route'
import { Route as AuthenticatedDomainsRouteRouteImport } from './routes/_authenticated/domains/route'
import { Route as StaffAuthenticatedRouteRouteImport } from './routes/staff/_authenticated/route'
import { Route as StaffEnrolRouteImport } from './routes/staff/enrol'
import { Route as StaffLoginRouteImport } from './routes/staff/login'
import { Route as StaffSetPasswordRouteImport } from './routes/staff/set-password'
import { Route as AuthenticatedBillingIndexRouteImport } from './routes/_authenticated/billing/index'
import { Route as AuthenticatedBillingTopUpsRouteImport } from './routes/_authenticated/billing/top-ups'
import { Route as AuthenticatedContactsIndexRouteImport } from './routes/_authenticated/contacts/index'
import { Route as AuthenticatedContactsContactIdRouteImport } from './routes/_authenticated/contacts/$contactId'
import { Route as AuthenticatedDashboardIndexRouteImport } from './routes/_authenticated/dashboard/index'
import { Route as AuthenticatedDomainsPricingRouteImport } from './routes/_authenticated/domains/pricing'
import { Route as AuthenticatedDomainsSearchRouteImport } from './routes/_authenticated/domains/search'
import { Route as AuthenticatedSettingsApiKeysRouteImport } from './routes/_authenticated/settings/api-keys'
import { Route as AuthenticatedSettingsMembersRouteImport } from './routes/_authenticated/settings/members'
import { Route as AuthenticatedSettingsProfileRouteImport } from './routes/_authenticated/settings/profile'
import { Route as StaffAuthenticatedIndexRouteImport } from './routes/staff/_authenticated/index'
import { Route as StaffAuthenticatedDomainsRouteRouteImport } from './routes/staff/_authenticated/domains/route'
import { Route as StaffAuthenticatedResellersRouteRouteImport } from './routes/staff/_authenticated/resellers/route'
import { Route as StaffAuthenticatedStaffRouteImport } from './routes/staff/_authenticated/staff'
import { Route as StaffAuthenticatedTopUpsRouteImport } from './routes/staff/_authenticated/top-ups'
import { Route as AuthenticatedBillingFakePayReferenceRouteImport } from './routes/_authenticated/billing/fake-pay.$reference'
import { Route as StaffAuthenticatedDomainsPricingRouteImport } from './routes/staff/_authenticated/domains/pricing'
import { Route as StaffAuthenticatedResellersIndexRouteImport } from './routes/staff/_authenticated/resellers/index'
import { Route as StaffAuthenticatedResellersResellerIdRouteImport } from './routes/staff/_authenticated/resellers/$resellerId'

const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const publicIndexRoute = publicIndexRouteImport.update({
  id: '/(public)/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const publicApplyRoute = publicApplyRouteImport.update({
  id: '/(public)/apply',
  path: '/apply',
  getParentRoute: () => rootRouteImport,
} as any)
const publicForgotPasswordRoute = publicForgotPasswordRouteImport.update({
  id: '/(public)/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const publicJoinRoute = publicJoinRouteImport.update({
  id: '/(public)/join',
  path: '/join',
  getParentRoute: () => rootRouteImport,
} as any)
const publicLoginRoute = publicLoginRouteImport.update({
  id: '/(public)/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const publicResetPasswordRoute = publicResetPasswordRouteImport.update({
  id: '/(public)/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedBillingRouteRoute =
  AuthenticatedBillingRouteRouteImport.update({
    id: '/billing',
    path: '/billing',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedContactsRouteRoute =
  AuthenticatedContactsRouteRouteImport.update({
    id: '/contacts',
    path: '/contacts',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDomainsRouteRoute =
  AuthenticatedDomainsRouteRouteImport.update({
    id: '/domains',
    path: '/domains',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const StaffAuthenticatedRouteRoute = StaffAuthenticatedRouteRouteImport.update({
  id: '/staff/_authenticated',
  path: '/staff',
  getParentRoute: () => rootRouteImport,
} as any)
const StaffEnrolRoute = StaffEnrolRouteImport.update({
  id: '/staff/enrol',
  path: '/staff/enrol',
  getParentRoute: () => rootRouteImport,
} as any)
const StaffLoginRoute = StaffLoginRouteImport.update({
  id: '/staff/login',
  path: '/staff/login',
  getParentRoute: () => rootRouteImport,
} as any)
const StaffSetPasswordRoute = StaffSetPasswordRouteImport.update({
  id: '/staff/set-password',
  path: '/staff/set-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedBillingIndexRoute =
  AuthenticatedBillingIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedBillingRouteRoute,
  } as any)
const AuthenticatedBillingTopUpsRoute =
  AuthenticatedBillingTopUpsRouteImport.update({
    id: '/top-ups',
    path: '/top-ups',
    getParentRoute: () => AuthenticatedBillingRouteRoute,
  } as any)
const AuthenticatedContactsIndexRoute =
  AuthenticatedContactsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedContactsRouteRoute,
  } as any)
const AuthenticatedContactsContactIdRoute =
  AuthenticatedContactsContactIdRouteImport.update({
    id: '/$contactId',
    path: '/$contactId',
    getParentRoute: () => AuthenticatedContactsRouteRoute,
  } as any)
const AuthenticatedDashboardIndexRoute =
  AuthenticatedDashboardIndexRouteImport.update({
    id: '/dashboard/',
    path: '/dashboard/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedDomainsPricingRoute =
  AuthenticatedDomainsPricingRouteImport.update({
    id: '/pricing',
    path: '/pricing',
    getParentRoute: () => AuthenticatedDomainsRouteRoute,
  } as any)
const AuthenticatedDomainsSearchRoute =
  AuthenticatedDomainsSearchRouteImport.update({
    id: '/search',
    path: '/search',
    getParentRoute: () => AuthenticatedDomainsRouteRoute,
  } as any)
const AuthenticatedSettingsApiKeysRoute =
  AuthenticatedSettingsApiKeysRouteImport.update({
    id: '/settings/api-keys',
    path: '/settings/api-keys',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSettingsMembersRoute =
  AuthenticatedSettingsMembersRouteImport.update({
    id: '/settings/members',
    path: '/settings/members',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedSettingsProfileRoute =
  AuthenticatedSettingsProfileRouteImport.update({
    id: '/settings/profile',
    path: '/settings/profile',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const StaffAuthenticatedIndexRoute = StaffAuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => StaffAuthenticatedRouteRoute,
} as any)
const StaffAuthenticatedDomainsRouteRoute =
  StaffAuthenticatedDomainsRouteRouteImport.update({
    id: '/domains',
    path: '/domains',
    getParentRoute: () => StaffAuthenticatedRouteRoute,
  } as any)
const StaffAuthenticatedResellersRouteRoute =
  StaffAuthenticatedResellersRouteRouteImport.update({
    id: '/resellers',
    path: '/resellers',
    getParentRoute: () => StaffAuthenticatedRouteRoute,
  } as any)
const StaffAuthenticatedStaffRoute = StaffAuthenticatedStaffRouteImport.update({
  id: '/staff',
  path: '/staff',
  getParentRoute: () => StaffAuthenticatedRouteRoute,
} as any)
const StaffAuthenticatedTopUpsRoute =
  StaffAuthenticatedTopUpsRouteImport.update({
    id: '/top-ups',
    path: '/top-ups',
    getParentRoute: () => StaffAuthenticatedRouteRoute,
  } as any)
const AuthenticatedBillingFakePayReferenceRoute =
  AuthenticatedBillingFakePayReferenceRouteImport.update({
    id: '/fake-pay/$reference',
    path: '/fake-pay/$reference',
    getParentRoute: () => AuthenticatedBillingRouteRoute,
  } as any)
const StaffAuthenticatedDomainsPricingRoute =
  StaffAuthenticatedDomainsPricingRouteImport.update({
    id: '/pricing',
    path: '/pricing',
    getParentRoute: () => StaffAuthenticatedDomainsRouteRoute,
  } as any)
const StaffAuthenticatedResellersIndexRoute =
  StaffAuthenticatedResellersIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StaffAuthenticatedResellersRouteRoute,
  } as any)
const StaffAuthenticatedResellersResellerIdRoute =
  StaffAuthenticatedResellersResellerIdRouteImport.update({
    id: '/$resellerId',
    path: '/$resellerId',
    getParentRoute: () => StaffAuthenticatedResellersRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof publicIndexRoute
  '/billing': typeof AuthenticatedBillingRouteRouteWithChildren
  '/contacts': typeof AuthenticatedContactsRouteRouteWithChildren
  '/domains': typeof AuthenticatedDomainsRouteRouteWithChildren
  '/staff': typeof StaffAuthenticatedRouteRouteWithChildren
  '/apply': typeof publicApplyRoute
  '/forgot-password': typeof publicForgotPasswordRoute
  '/join': typeof publicJoinRoute
  '/login': typeof publicLoginRoute
  '/reset-password': typeof publicResetPasswordRoute
  '/staff/enrol': typeof StaffEnrolRoute
  '/staff/login': typeof StaffLoginRoute
  '/staff/set-password': typeof StaffSetPasswordRoute
  '/staff/domains': typeof StaffAuthenticatedDomainsRouteRouteWithChildren
  '/staff/resellers': typeof StaffAuthenticatedResellersRouteRouteWithChildren
  '/billing/top-ups': typeof AuthenticatedBillingTopUpsRoute
  '/contacts/$contactId': typeof AuthenticatedContactsContactIdRoute
  '/domains/pricing': typeof AuthenticatedDomainsPricingRoute
  '/domains/search': typeof AuthenticatedDomainsSearchRoute
  '/settings/api-keys': typeof AuthenticatedSettingsApiKeysRoute
  '/settings/members': typeof AuthenticatedSettingsMembersRoute
  '/settings/profile': typeof AuthenticatedSettingsProfileRoute
  '/staff/staff': typeof StaffAuthenticatedStaffRoute
  '/staff/top-ups': typeof StaffAuthenticatedTopUpsRoute
  '/billing/': typeof AuthenticatedBillingIndexRoute
  '/contacts/': typeof AuthenticatedContactsIndexRoute
  '/dashboard/': typeof AuthenticatedDashboardIndexRoute
  '/staff/': typeof StaffAuthenticatedIndexRoute
  '/billing/fake-pay/$reference': typeof AuthenticatedBillingFakePayReferenceRoute
  '/staff/domains/pricing': typeof StaffAuthenticatedDomainsPricingRoute
  '/staff/resellers/$resellerId': typeof StaffAuthenticatedResellersResellerIdRoute
  '/staff/resellers/': typeof StaffAuthenticatedResellersIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof publicIndexRoute
  '/domains': typeof AuthenticatedDomainsRouteRouteWithChildren
  '/apply': typeof publicApplyRoute
  '/forgot-password': typeof publicForgotPasswordRoute
  '/join': typeof publicJoinRoute
  '/login': typeof publicLoginRoute
  '/reset-password': typeof publicResetPasswordRoute
  '/staff/enrol': typeof StaffEnrolRoute
  '/staff/login': typeof StaffLoginRoute
  '/staff/set-password': typeof StaffSetPasswordRoute
  '/staff/domains': typeof StaffAuthenticatedDomainsRouteRouteWithChildren
  '/billing/top-ups': typeof AuthenticatedBillingTopUpsRoute
  '/contacts/$contactId': typeof AuthenticatedContactsContactIdRoute
  '/domains/pricing': typeof AuthenticatedDomainsPricingRoute
  '/domains/search': typeof AuthenticatedDomainsSearchRoute
  '/settings/api-keys': typeof AuthenticatedSettingsApiKeysRoute
  '/settings/members': typeof AuthenticatedSettingsMembersRoute
  '/settings/profile': typeof AuthenticatedSettingsProfileRoute
  '/staff/staff': typeof StaffAuthenticatedStaffRoute
  '/staff/top-ups': typeof StaffAuthenticatedTopUpsRoute
  '/billing': typeof AuthenticatedBillingIndexRoute
  '/contacts': typeof AuthenticatedContactsIndexRoute
  '/dashboard': typeof AuthenticatedDashboardIndexRoute
  '/staff': typeof StaffAuthenticatedIndexRoute
  '/billing/fake-pay/$reference': typeof AuthenticatedBillingFakePayReferenceRoute
  '/staff/domains/pricing': typeof StaffAuthenticatedDomainsPricingRoute
  '/staff/resellers/$resellerId': typeof StaffAuthenticatedResellersResellerIdRoute
  '/staff/resellers': typeof StaffAuthenticatedResellersIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteRouteWithChildren
  '/_authenticated/billing': typeof AuthenticatedBillingRouteRouteWithChildren
  '/_authenticated/contacts': typeof AuthenticatedContactsRouteRouteWithChildren
  '/_authenticated/domains': typeof AuthenticatedDomainsRouteRouteWithChildren
  '/staff/_authenticated': typeof StaffAuthenticatedRouteRouteWithChildren
  '/(public)/apply': typeof publicApplyRoute
  '/(public)/forgot-password': typeof publicForgotPasswordRoute
  '/(public)/join': typeof publicJoinRoute
  '/(public)/login': typeof publicLoginRoute
  '/(public)/reset-password': typeof publicResetPasswordRoute
  '/staff/enrol': typeof StaffEnrolRoute
  '/staff/login': typeof StaffLoginRoute
  '/staff/set-password': typeof StaffSetPasswordRoute
  '/(public)/': typeof publicIndexRoute
  '/staff/_authenticated/domains': typeof StaffAuthenticatedDomainsRouteRouteWithChildren
  '/staff/_authenticated/resellers': typeof StaffAuthenticatedResellersRouteRouteWithChildren
  '/_authenticated/billing/top-ups': typeof AuthenticatedBillingTopUpsRoute
  '/_authenticated/contacts/$contactId': typeof AuthenticatedContactsContactIdRoute
  '/_authenticated/domains/pricing': typeof AuthenticatedDomainsPricingRoute
  '/_authenticated/domains/search': typeof AuthenticatedDomainsSearchRoute
  '/_authenticated/settings/api-keys': typeof AuthenticatedSettingsApiKeysRoute
  '/_authenticated/settings/members': typeof AuthenticatedSettingsMembersRoute
  '/_authenticated/settings/profile': typeof AuthenticatedSettingsProfileRoute
  '/staff/_authenticated/staff': typeof StaffAuthenticatedStaffRoute
  '/staff/_authenticated/top-ups': typeof StaffAuthenticatedTopUpsRoute
  '/_authenticated/billing/': typeof AuthenticatedBillingIndexRoute
  '/_authenticated/contacts/': typeof AuthenticatedContactsIndexRoute
  '/_authenticated/dashboard/': typeof AuthenticatedDashboardIndexRoute
  '/staff/_authenticated/': typeof StaffAuthenticatedIndexRoute
  '/_authenticated/billing/fake-pay/$reference': typeof AuthenticatedBillingFakePayReferenceRoute
  '/staff/_authenticated/domains/pricing': typeof StaffAuthenticatedDomainsPricingRoute
  '/staff/_authenticated/resellers/$resellerId': typeof StaffAuthenticatedResellersResellerIdRoute
  '/staff/_authenticated/resellers/': typeof StaffAuthenticatedResellersIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/billing'
    | '/contacts'
    | '/domains'
    | '/staff'
    | '/apply'
    | '/forgot-password'
    | '/join'
    | '/login'
    | '/reset-password'
    | '/staff/enrol'
    | '/staff/login'
    | '/staff/set-password'
    | '/staff/domains'
    | '/staff/resellers'
    | '/billing/top-ups'
    | '/contacts/$contactId'
    | '/domains/pricing'
    | '/domains/search'
    | '/settings/api-keys'
    | '/settings/members'
    | '/settings/profile'
    | '/staff/staff'
    | '/staff/top-ups'
    | '/billing/'
    | '/contacts/'
    | '/dashboard/'
    | '/staff/'
    | '/billing/fake-pay/$reference'
    | '/staff/domains/pricing'
    | '/staff/resellers/$resellerId'
    | '/staff/resellers/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/domains'
    | '/apply'
    | '/forgot-password'
    | '/join'
    | '/login'
    | '/reset-password'
    | '/staff/enrol'
    | '/staff/login'
    | '/staff/set-password'
    | '/staff/domains'
    | '/billing/top-ups'
    | '/contacts/$contactId'
    | '/domains/pricing'
    | '/domains/search'
    | '/settings/api-keys'
    | '/settings/members'
    | '/settings/profile'
    | '/staff/staff'
    | '/staff/top-ups'
    | '/billing'
    | '/contacts'
    | '/dashboard'
    | '/staff'
    | '/billing/fake-pay/$reference'
    | '/staff/domains/pricing'
    | '/staff/resellers/$resellerId'
    | '/staff/resellers'
  id:
    | '__root__'
    | '/_authenticated'
    | '/_authenticated/billing'
    | '/_authenticated/contacts'
    | '/_authenticated/domains'
    | '/staff/_authenticated'
    | '/(public)/apply'
    | '/(public)/forgot-password'
    | '/(public)/join'
    | '/(public)/login'
    | '/(public)/reset-password'
    | '/staff/enrol'
    | '/staff/login'
    | '/staff/set-password'
    | '/(public)/'
    | '/staff/_authenticated/domains'
    | '/staff/_authenticated/resellers'
    | '/_authenticated/billing/top-ups'
    | '/_authenticated/contacts/$contactId'
    | '/_authenticated/domains/pricing'
    | '/_authenticated/domains/search'
    | '/_authenticated/settings/api-keys'
    | '/_authenticated/settings/members'
    | '/_authenticated/settings/profile'
    | '/staff/_authenticated/staff'
    | '/staff/_authenticated/top-ups'
    | '/_authenticated/billing/'
    | '/_authenticated/contacts/'
    | '/_authenticated/dashboard/'
    | '/staff/_authenticated/'
    | '/_authenticated/billing/fake-pay/$reference'
    | '/staff/_authenticated/domains/pricing'
    | '/staff/_authenticated/resellers/$resellerId'
    | '/staff/_authenticated/resellers/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRouteRoute: typeof AuthenticatedRouteRouteWithChildren
  StaffAuthenticatedRouteRoute: typeof StaffAuthenticatedRouteRouteWithChildren
  publicApplyRoute: typeof publicApplyRoute
  publicForgotPasswordRoute: typeof publicForgotPasswordRoute
  publicJoinRoute: typeof publicJoinRoute
  publicLoginRoute: typeof publicLoginRoute
  publicResetPasswordRoute: typeof publicResetPasswordRoute
  StaffEnrolRoute: typeof StaffEnrolRoute
  StaffLoginRoute: typeof StaffLoginRoute
  StaffSetPasswordRoute: typeof StaffSetPasswordRoute
  publicIndexRoute: typeof publicIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(public)/': {
      id: '/(public)/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof publicIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(public)/apply': {
      id: '/(public)/apply'
      path: '/apply'
      fullPath: '/apply'
      preLoaderRoute: typeof publicApplyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(public)/forgot-password': {
      id: '/(public)/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof publicForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(public)/join': {
      id: '/(public)/join'
      path: '/join'
      fullPath: '/join'
      preLoaderRoute: typeof publicJoinRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(public)/login': {
      id: '/(public)/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof publicLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(public)/reset-password': {
      id: '/(public)/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof publicResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/billing': {
      id: '/_authenticated/billing'
      path: '/billing'
      fullPath: '/billing'
      preLoaderRoute: typeof AuthenticatedBillingRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/contacts': {
      id: '/_authenticated/contacts'
      path: '/contacts'
      fullPath: '/contacts'
      preLoaderRoute: typeof AuthenticatedContactsRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/domains': {
      id: '/_authenticated/domains'
      path: '/domains'
      fullPath: '/domains'
      preLoaderRoute: typeof AuthenticatedDomainsRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/staff/_authenticated': {
      id: '/staff/_authenticated'
      path: '/staff'
      fullPath: '/staff'
      preLoaderRoute: typeof StaffAuthenticatedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/staff/enrol': {
      id: '/staff/enrol'
      path: '/staff/enrol'
      fullPath: '/staff/enrol'
      preLoaderRoute: typeof StaffEnrolRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/staff/login': {
      id: '/staff/login'
      path: '/staff/login'
      fullPath: '/staff/login'
      preLoaderRoute: typeof StaffLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/staff/set-password': {
      id: '/staff/set-password'
      path: '/staff/set-password'
      fullPath: '/staff/set-password'
      preLoaderRoute: typeof StaffSetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/billing/': {
      id: '/_authenticated/billing/'
      path: '/'
      fullPath: '/billing/'
      preLoaderRoute: typeof AuthenticatedBillingIndexRouteImport
      parentRoute: typeof AuthenticatedBillingRouteRoute
    }
    '/_authenticated/billing/top-ups': {
      id: '/_authenticated/billing/top-ups'
      path: '/top-ups'
      fullPath: '/billing/top-ups'
      preLoaderRoute: typeof AuthenticatedBillingTopUpsRouteImport
      parentRoute: typeof AuthenticatedBillingRouteRoute
    }
    '/_authenticated/contacts/': {
      id: '/_authenticated/contacts/'
      path: '/'
      fullPath: '/contacts/'
      preLoaderRoute: typeof AuthenticatedContactsIndexRouteImport
      parentRoute: typeof AuthenticatedContactsRouteRoute
    }
    '/_authenticated/contacts/$contactId': {
      id: '/_authenticated/contacts/$contactId'
      path: '/$contactId'
      fullPath: '/contacts/$contactId'
      preLoaderRoute: typeof AuthenticatedContactsContactIdRouteImport
      parentRoute: typeof AuthenticatedContactsRouteRoute
    }
    '/_authenticated/dashboard/': {
      id: '/_authenticated/dashboard/'
      path: '/dashboard'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof AuthenticatedDashboardIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/domains/pricing': {
      id: '/_authenticated/domains/pricing'
      path: '/pricing'
      fullPath: '/domains/pricing'
      preLoaderRoute: typeof AuthenticatedDomainsPricingRouteImport
      parentRoute: typeof AuthenticatedDomainsRouteRoute
    }
    '/_authenticated/domains/search': {
      id: '/_authenticated/domains/search'
      path: '/search'
      fullPath: '/domains/search'
      preLoaderRoute: typeof AuthenticatedDomainsSearchRouteImport
      parentRoute: typeof AuthenticatedDomainsRouteRoute
    }
    '/_authenticated/settings/api-keys': {
      id: '/_authenticated/settings/api-keys'
      path: '/settings/api-keys'
      fullPath: '/settings/api-keys'
      preLoaderRoute: typeof AuthenticatedSettingsApiKeysRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/settings/members': {
      id: '/_authenticated/settings/members'
      path: '/settings/members'
      fullPath: '/settings/members'
      preLoaderRoute: typeof AuthenticatedSettingsMembersRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/settings/profile': {
      id: '/_authenticated/settings/profile'
      path: '/settings/profile'
      fullPath: '/settings/profile'
      preLoaderRoute: typeof AuthenticatedSettingsProfileRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/staff/_authenticated/': {
      id: '/staff/_authenticated/'
      path: '/'
      fullPath: '/staff/'
      preLoaderRoute: typeof StaffAuthenticatedIndexRouteImport
      parentRoute: typeof StaffAuthenticatedRouteRoute
    }
    '/staff/_authenticated/domains': {
      id: '/staff/_authenticated/domains'
      path: '/domains'
      fullPath: '/staff/domains'
      preLoaderRoute: typeof StaffAuthenticatedDomainsRouteRouteImport
      parentRoute: typeof StaffAuthenticatedRouteRoute
    }
    '/staff/_authenticated/resellers': {
      id: '/staff/_authenticated/resellers'
      path: '/resellers'
      fullPath: '/staff/resellers'
      preLoaderRoute: typeof StaffAuthenticatedResellersRouteRouteImport
      parentRoute: typeof StaffAuthenticatedRouteRoute
    }
    '/staff/_authenticated/staff': {
      id: '/staff/_authenticated/staff'
      path: '/staff'
      fullPath: '/staff/staff'
      preLoaderRoute: typeof StaffAuthenticatedStaffRouteImport
      parentRoute: typeof StaffAuthenticatedRouteRoute
    }
    '/staff/_authenticated/top-ups': {
      id: '/staff/_authenticated/top-ups'
      path: '/top-ups'
      fullPath: '/staff/top-ups'
      preLoaderRoute: typeof StaffAuthenticatedTopUpsRouteImport
      parentRoute: typeof StaffAuthenticatedRouteRoute
    }
    '/_authenticated/billing/fake-pay/$reference': {
      id: '/_authenticated/billing/fake-pay/$reference'
      path: '/fake-pay/$reference'
      fullPath: '/billing/fake-pay/$reference'
      preLoaderRoute: typeof AuthenticatedBillingFakePayReferenceRouteImport
      parentRoute: typeof AuthenticatedBillingRouteRoute
    }
    '/staff/_authenticated/domains/pricing': {
      id: '/staff/_authenticated/domains/pricing'
      path: '/pricing'
      fullPath: '/staff/domains/pricing'
      preLoaderRoute: typeof StaffAuthenticatedDomainsPricingRouteImport
      parentRoute: typeof StaffAuthenticatedDomainsRouteRoute
    }
    '/staff/_authenticated/resellers/': {
      id: '/staff/_authenticated/resellers/'
      path: '/'
      fullPath: '/staff/resellers/'
      preLoaderRoute: typeof StaffAuthenticatedResellersIndexRouteImport
      parentRoute: typeof StaffAuthenticatedResellersRouteRoute
    }
    '/staff/_authenticated/resellers/$resellerId': {
      id: '/staff/_authenticated/resellers/$resellerId'
      path: '/$resellerId'
      fullPath: '/staff/resellers/$resellerId'
      preLoaderRoute: typeof StaffAuthenticatedResellersResellerIdRouteImport
      parentRoute: typeof StaffAuthenticatedResellersRouteRoute
    }
  }
}

interface AuthenticatedBillingRouteRouteChildren {
  AuthenticatedBillingTopUpsRoute: typeof AuthenticatedBillingTopUpsRoute
  AuthenticatedBillingIndexRoute: typeof AuthenticatedBillingIndexRoute
  AuthenticatedBillingFakePayReferenceRoute: typeof AuthenticatedBillingFakePayReferenceRoute
}

const AuthenticatedBillingRouteRouteChildren: AuthenticatedBillingRouteRouteChildren =
  {
    AuthenticatedBillingTopUpsRoute: AuthenticatedBillingTopUpsRoute,
    AuthenticatedBillingIndexRoute: AuthenticatedBillingIndexRoute,
    AuthenticatedBillingFakePayReferenceRoute:
      AuthenticatedBillingFakePayReferenceRoute,
  }

const AuthenticatedBillingRouteRouteWithChildren =
  AuthenticatedBillingRouteRoute._addFileChildren(
    AuthenticatedBillingRouteRouteChildren,
  )

interface AuthenticatedContactsRouteRouteChildren {
  AuthenticatedContactsContactIdRoute: typeof AuthenticatedContactsContactIdRoute
  AuthenticatedContactsIndexRoute: typeof AuthenticatedContactsIndexRoute
}

const AuthenticatedContactsRouteRouteChildren: AuthenticatedContactsRouteRouteChildren =
  {
    AuthenticatedContactsContactIdRoute: AuthenticatedContactsContactIdRoute,
    AuthenticatedContactsIndexRoute: AuthenticatedContactsIndexRoute,
  }

const AuthenticatedContactsRouteRouteWithChildren =
  AuthenticatedContactsRouteRoute._addFileChildren(
    AuthenticatedContactsRouteRouteChildren,
  )

interface AuthenticatedDomainsRouteRouteChildren {
  AuthenticatedDomainsPricingRoute: typeof AuthenticatedDomainsPricingRoute
  AuthenticatedDomainsSearchRoute: typeof AuthenticatedDomainsSearchRoute
}

const AuthenticatedDomainsRouteRouteChildren: AuthenticatedDomainsRouteRouteChildren =
  {
    AuthenticatedDomainsPricingRoute: AuthenticatedDomainsPricingRoute,
    AuthenticatedDomainsSearchRoute: AuthenticatedDomainsSearchRoute,
  }

const AuthenticatedDomainsRouteRouteWithChildren =
  AuthenticatedDomainsRouteRoute._addFileChildren(
    AuthenticatedDomainsRouteRouteChildren,
  )

interface AuthenticatedRouteRouteChildren {
  AuthenticatedBillingRouteRoute: typeof AuthenticatedBillingRouteRouteWithChildren
  AuthenticatedContactsRouteRoute: typeof AuthenticatedContactsRouteRouteWithChildren
  AuthenticatedDomainsRouteRoute: typeof AuthenticatedDomainsRouteRouteWithChildren
  AuthenticatedSettingsApiKeysRoute: typeof AuthenticatedSettingsApiKeysRoute
  AuthenticatedSettingsMembersRoute: typeof AuthenticatedSettingsMembersRoute
  AuthenticatedSettingsProfileRoute: typeof AuthenticatedSettingsProfileRoute
  AuthenticatedDashboardIndexRoute: typeof AuthenticatedDashboardIndexRoute
}

const AuthenticatedRouteRouteChildren: AuthenticatedRouteRouteChildren = {
  AuthenticatedBillingRouteRoute: AuthenticatedBillingRouteRouteWithChildren,
  AuthenticatedContactsRouteRoute: AuthenticatedContactsRouteRouteWithChildren,
  AuthenticatedDomainsRouteRoute: AuthenticatedDomainsRouteRouteWithChildren,
  AuthenticatedSettingsApiKeysRoute: AuthenticatedSettingsApiKeysRoute,
  AuthenticatedSettingsMembersRoute: AuthenticatedSettingsMembersRoute,
  AuthenticatedSettingsProfileRoute: AuthenticatedSettingsProfileRoute,
  AuthenticatedDashboardIndexRoute: AuthenticatedDashboardIndexRoute,
}

const AuthenticatedRouteRouteWithChildren =
  AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

interface StaffAuthenticatedDomainsRouteRouteChildren {
  StaffAuthenticatedDomainsPricingRoute: typeof StaffAuthenticatedDomainsPricingRoute
}

const StaffAuthenticatedDomainsRouteRouteChildren: StaffAuthenticatedDomainsRouteRouteChildren =
  {
    StaffAuthenticatedDomainsPricingRoute:
      StaffAuthenticatedDomainsPricingRoute,
  }

const StaffAuthenticatedDomainsRouteRouteWithChildren =
  StaffAuthenticatedDomainsRouteRoute._addFileChildren(
    StaffAuthenticatedDomainsRouteRouteChildren,
  )

interface StaffAuthenticatedResellersRouteRouteChildren {
  StaffAuthenticatedResellersResellerIdRoute: typeof StaffAuthenticatedResellersResellerIdRoute
  StaffAuthenticatedResellersIndexRoute: typeof StaffAuthenticatedResellersIndexRoute
}

const StaffAuthenticatedResellersRouteRouteChildren: StaffAuthenticatedResellersRouteRouteChildren =
  {
    StaffAuthenticatedResellersResellerIdRoute:
      StaffAuthenticatedResellersResellerIdRoute,
    StaffAuthenticatedResellersIndexRoute:
      StaffAuthenticatedResellersIndexRoute,
  }

const StaffAuthenticatedResellersRouteRouteWithChildren =
  StaffAuthenticatedResellersRouteRoute._addFileChildren(
    StaffAuthenticatedResellersRouteRouteChildren,
  )

interface StaffAuthenticatedRouteRouteChildren {
  StaffAuthenticatedDomainsRouteRoute: typeof StaffAuthenticatedDomainsRouteRouteWithChildren
  StaffAuthenticatedResellersRouteRoute: typeof StaffAuthenticatedResellersRouteRouteWithChildren
  StaffAuthenticatedStaffRoute: typeof StaffAuthenticatedStaffRoute
  StaffAuthenticatedTopUpsRoute: typeof StaffAuthenticatedTopUpsRoute
  StaffAuthenticatedIndexRoute: typeof StaffAuthenticatedIndexRoute
}

const StaffAuthenticatedRouteRouteChildren: StaffAuthenticatedRouteRouteChildren =
  {
    StaffAuthenticatedDomainsRouteRoute:
      StaffAuthenticatedDomainsRouteRouteWithChildren,
    StaffAuthenticatedResellersRouteRoute:
      StaffAuthenticatedResellersRouteRouteWithChildren,
    StaffAuthenticatedStaffRoute: StaffAuthenticatedStaffRoute,
    StaffAuthenticatedTopUpsRoute: StaffAuthenticatedTopUpsRoute,
    StaffAuthenticatedIndexRoute: StaffAuthenticatedIndexRoute,
  }

const StaffAuthenticatedRouteRouteWithChildren =
  StaffAuthenticatedRouteRoute._addFileChildren(
    StaffAuthenticatedRouteRouteChildren,
  )

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,
  StaffAuthenticatedRouteRoute: StaffAuthenticatedRouteRouteWithChildren,
  publicApplyRoute: publicApplyRoute,
  publicForgotPasswordRoute: publicForgotPasswordRoute,
  publicJoinRoute: publicJoinRoute,
  publicLoginRoute: publicLoginRoute,
  publicResetPasswordRoute: publicResetPasswordRoute,
  StaffEnrolRoute: StaffEnrolRoute,
  StaffLoginRoute: StaffLoginRoute,
  StaffSetPasswordRoute: StaffSetPasswordRoute,
  publicIndexRoute: publicIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
